
/* for smooth scroll start*/
   function smoothScroll(event, targetId) {
  event.preventDefault();
  
  const targetElement = document.querySelector(targetId);
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  const duration = 1000; // Adjust the duration as needed
  
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) {
      startTime = currentTime;
    }

    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    window.scrollTo(0, startPosition + distance * ease(progress));

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  function ease(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }

  requestAnimationFrame(animation);
}
/* for smooth scroll end*/

/* video change on div click start*/

    

/* video change on div click end*/
/* to show popup start*/
function openPopup() {
  var popup = document.getElementById('popup');
  popup.style.display = 'flex';
}

function closePopup() {
  var popup = document.getElementById('popup');
  popup.style.display = 'none';
}
/* to show popup end*/
/* to show accordion start*/
 
/*const accordion = document.getElementsByClassName('container');
            for (i = 0; i < accordion.length; i++) {
                accordion[i].addEventListener('click', function () {
                    this.classList.add('active');
                });
            
      
            }*/
const accordions = document.querySelectorAll('.container');

  accordions.forEach((accordion) => {
    accordion.addEventListener('click', function() {
      // Toggle active class for the clicked accordion
      this.classList.toggle('active');

      // Close other accordions
      accordions.forEach((otherAccordion) => {
        if (otherAccordion !== accordion) {
          otherAccordion.classList.remove('active');
        }
      });
    });
  });

/* to show accordion end*/


/* timer start*/
function startTimer() {
  // Set the initial target time (24 hours from now)
  let targetTime = new Date().getTime() + 24 * 60 * 60 * 1000;

  // Update the countdown every second
  const countdown = setInterval(function() {
    // Get the current date and time
    const now = new Date().getTime();

    // Calculate the distance between the current date and the target time
    const distance = targetTime - now;

    // Calculate hours, minutes, and seconds
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the countdown in the 'countdown' div
    document.getElementById('hours').innerHTML = `<div>${hours}</div>`;
    document.getElementById('minutes').innerHTML = `<div>${minutes}</div>`;
    document.getElementById('seconds').innerHTML = `<div>${seconds}</div>`;

    // If the countdown is over (24 hours), reset the timer
    if (distance < 0) {
      clearInterval(countdown);
      startTimer(); // Restart the timer
    }
  }, 1000); // Update every second
}

// Start the timer initially
startTimer();
/* timer end*/
